import React from "react";

const Gracias = ({tarjeta}) => {
    return(
        <div id="gracias">
            <div className="container">
            <div className="content">
            <div className="titulo_gracias">
                <img src="img/gracias.png" alt="titulo"></img>
            </div>
            <div className="tarjeta_gracias">
                {
                    tarjeta === 0 ?
                        <img src="img/tarjeta-amex-clasica.png" alt="clasica"></img>
                    :
                        tarjeta === 1 ?
                            <img src="img/tarjeta-amex-gold.png" alt="gold"></img>
                            :
                            tarjeta === 2 ?
                                <img src="img/tarjeta-amex-platinum.png" alt="platinum"></img>
                                :
                                null
                }
            
            </div>
            <div className="logo_gracias">
                <img src="img/logo.png" alt="logo"></img>
            </div>
            </div>
            </div>
        </div>
    );
}

export default Gracias;